export default __webpack_public_path__ + "0ac9dbf44a62ee2b4829369f0eb3fa2c.svg";